/**
 * @param {Function} callback
 * @return {jQuery}
 */
function RegisterDialog(callback) {
    var $ = jQuery;

    var TEMPLATE = '<div class="RegisterDialog dialog">' +
        '<p class="REGISTER_DIALOG_MESSAGE">Please register your account to play the game</p>' +
        '<a href="#" onclick="return false" class="button REGISTER_DIALOG_RUN">Register!</a>' +
        '</div>';

    var dialog = $(TEMPLATE);
    dialog.find(".REGISTER_DIALOG_MESSAGE").text(L10N.getString("REGISTER_DIALOG_MESSAGE"));
    dialog.find(".REGISTER_DIALOG_RUN").text(L10N.getString("REGISTER_DIALOG_RUN"));
    dialog.find('.button').click(callback);

    return dialog;
}